import React, { Component } from "react";

export default class Services extends Component {
  render() {
    return (
      <div>
        <section className="section-services " id="services">
          <div className="row ">
            <div className="col-sm-12">
              <h2>Our Services</h2>
              <h3>
                We are dedicated to client success and providing innovation that
                matters.
              </h3>
            </div> 
            </div>

            <div className="container">
              <div className="services-box">
                <div className="services-step">
                  <p className="services-title">SOLUTIONS</p>
                  <p>
                    Mobile Strategy Architecture
                    <br />
                    Application Concept & Design
                    <br />
                    iOS, Android, & Web Development
                    <br />
                    Loyalty Programs & Gamification
                    <br />
                    Social Media Integration
                    <br />
                    Web Services & Integration
                    <br />
                    Data Management & Analytics
                    <br />
                    Enterprise Cloud Integration
                    <br />
                    Solutions for the Internet of Things
                  </p>
                </div>
              </div>
              <div className="services-image-box">
                <img
                  src={require("../../assets/img/smilefish_montecarlo.png")}
                  alt="Smilestein app on iPhone"
                />
              </div>
            </div>
         </section>
      </div>
    );
  }
}
